import { Api } from "../config/request";

export default {
  getCityProperty(payload) {
    return Api.post("/config/city-property", payload);
  },
  updateCityProperty(id, payload) {
    return Api.put(`/config/city-property/${id}`, payload);
  },
  getCityPropertyChangeLog(queryParams, id) {
    return Api.get(
      `/config/city-property/change-logs/${id}${
        queryParams && queryParams.length > 0 ? `${queryParams}` : ""
      }`
    );
  },
  getCityPropKeys(queryParams, id) {
    return Api.get(
      `/config/city-property/keys/${id}${
        queryParams && queryParams.length > 0 ? `${queryParams}` : ""
      }`
    );
  },
};
